"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDateFilterConfig = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_filters_1 = require("@gooddata/sdk-ui-filters");
/**
 * Default implementation of the date filter config. This should be used in case the workspace
 * does not have
 */
exports.defaultDateFilterConfig = {
    ref: sdk_model_1.idRef("defaultDateFilterProjectConfig"),
    selectedOption: "THIS_MONTH",
    allTime: sdk_ui_filters_1.DateFilterHelpers.defaultDateFilterOptions.allTime,
    absoluteForm: sdk_ui_filters_1.DateFilterHelpers.defaultDateFilterOptions.absoluteForm,
    relativeForm: {
        type: "relativeForm",
        // month has to be the first as it should be the default selected option
        availableGranularities: ["GDC.time.month", "GDC.time.date", "GDC.time.quarter", "GDC.time.year"],
        localIdentifier: sdk_ui_filters_1.DateFilterHelpers.defaultDateFilterOptions.relativeForm.localIdentifier,
        name: sdk_ui_filters_1.DateFilterHelpers.defaultDateFilterOptions.relativeForm.name,
        visible: true,
    },
    relativePresets: Object.keys(sdk_ui_filters_1.DateFilterHelpers.defaultDateFilterOptions.relativePreset).reduce(function (presets, granularityKey) {
        var granularityPresets = sdk_ui_filters_1.DateFilterHelpers.defaultDateFilterOptions.relativePreset[granularityKey];
        presets.push.apply(presets, tslib_1.__spread(granularityPresets));
        return presets;
    }, []),
    absolutePresets: [],
};
//# sourceMappingURL=defaultConfig.js.map